import type { MouseEvent, SyntheticEvent } from 'react'
import { legacyHookAttrs, type LegacyContractName } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { dispatchSubsDisclosure } from '@/msgdeskRuntime/subsDisclosure'

// Modern fold button — self-contained (markup + wiring + Tailwind).
// ONE component for every fold: "Fold answers" / "Fold msges" (kind 'subs') and
// the main message "Fold msg" (kind 'msg'). Same behaviour and hook classes as
// ../Legacy; re-skinned via md-fold-subs--modern.

function stopEvent(event: SyntheticEvent) {
  event.preventDefault()
  event.stopPropagation()
}

export function FoldSubsButton({
  section = 0,
  label,
  count,
  kind = 'subs',
}: {
  section?: 0 | 1
  label: string
  count?: number
  kind?: 'subs' | 'msg'
}) {
  const isMsg = kind === 'msg'
  const contract: LegacyContractName = isMsg
    ? 'main.foldButton'
    : (section === 0 ? 'subs.menuToggle.answers' : 'subs.menuToggle.submsges')

  // BEHAVIOUR: fold/unfold the message body or a subs section.
  function handleFold(event: MouseEvent<HTMLElement>) {
    stopEvent(event)
    if (isMsg) dispatchSubsDisclosure({ action: 'toggle-main' })
    else dispatchSubsDisclosure({ action: 'toggle-section', section, target: event.currentTarget })
  }

  return (
    <a
      href="#"
      {...legacyHookAttrs(contract, 'md-hook-no-select md-fold-subs md-fold-subs--modern mr-[5px] mb-0.5 inline-flex flex-[0_0_auto] select-none items-center gap-1 rounded-[7px] bg-slate-100 px-2.5 py-[3px] text-[11px] font-semibold leading-none text-slate-600 no-underline transition-colors duration-150 hover:bg-slate-200 hover:text-[#2563eb]')}
      onClick={handleFold}
    >
      <span className="md-fold-subs__label">{label}</span>
      {!isMsg && (
        <span className="md-fold-subs__count text-slate-400">{typeof count === 'number' ? `(${count})` : ''}</span>
      )}
    </a>
  )
}
